import axios from 'axios';
import itemApi from '@/api/item';

export default {
  async getPayrollPreview({ dates, userIds } = {}) {
    return axios({
      url: '/api/tenant/netvisor/payroll-preview',
      params: {
        dates: (dates || []).join(',') || undefined,
        userIds: userIds?.join(',') || undefined,
      },
    }).then(r => r.data);
  },

  async exportPayroll({ periodStart, periodEnd, rows }) {
    return axios({
      method: 'POST',
      url: '/api/tenant/netvisor/export-payroll',
      data: { periodStart, periodEnd, rows },
    }).then(r => r.data);
  },

  async getExportLog() {
    return axios({ url: '/api/tenant/netvisor/export-log' }).then(r => r.data);
  },

  async getExportLogDetails(id) {
    return axios({ url: `/api/tenant/netvisor/export-log/${id}` }).then(r => r.data);
  },

  async getSitePurchaseInvoices(siteId) {
    return axios({ url: `/api/tenant/netvisor/site-purchase-invoices/${siteId}` }).then(r => r.data);
  },

  async getWarehousePurchaseInvoices() {
    return axios({ url: '/api/tenant/netvisor/warehouse-purchase-invoices' }).then(r => r.data);
  },

  async bookWarehouseLine(invoiceKey, lineKey, data) {
    itemApi.clearCache();
    return axios({
      method: 'POST',
      url: `/api/tenant/netvisor/warehouse-purchase-invoices/${invoiceKey}/lines/${lineKey}/bookings`,
      data,
    }).then(r => r.data);
  },

  async setWarehouseLineStatus(invoiceKey, lineKey, status, note) {
    return axios({
      method: 'PUT',
      url: `/api/tenant/netvisor/warehouse-purchase-invoices/${invoiceKey}/lines/${lineKey}/status`,
      data: { status, note },
    }).then(r => r.data);
  },

  async clearWarehouseLineStatus(invoiceKey, lineKey) {
    return axios({
      method: 'DELETE',
      url: `/api/tenant/netvisor/warehouse-purchase-invoices/${invoiceKey}/lines/${lineKey}/status`,
    }).then(r => r.data);
  },

  async syncPurchaseInvoices() {
    return axios({ method: 'POST', url: '/api/tenant/netvisor/purchase-invoices/sync' }).then(r => r.data);
  },

  async getSiteSalesInvoices(siteId) {
    return axios({ url: `/api/tenant/netvisor/site-sales-invoices/${siteId}` }).then(r => r.data);
  },

  async syncSalesInvoices() {
    return axios({ method: 'POST', url: '/api/tenant/netvisor/sales-invoices/sync' }).then(r => r.data);
  },
};
